import { AppDialog } from '../Common'
import { useNls } from '../../nls/nlsProvider'
import { JoinWithCodeForm, type ClaimedJoinCodeInfo } from './JoinWithCodeForm'

export type JoinWithCodeDialogProps = {
  open: boolean
  onClose: () => void
  onClaimed?: (claimed: ClaimedJoinCodeInfo) => void
  prefillCode?: string
}

export const JoinWithCodeDialog = ({
  open,
  onClose,
  onClaimed,
  prefillCode,
}: JoinWithCodeDialogProps) => {
  const { t } = useNls()

  return (
    <AppDialog
      open={open}
      title={t('NLSJoinWithCodeDialogTitle')}
      message={t('NLSJoinWithCodeDialogDescription')}
      onDismiss={onClose}
      size="sm"
      actions={[]}
    >
      <JoinWithCodeForm
        prefillCode={prefillCode}
        onClaimed={(claimed) => {
          onClaimed?.(claimed)
        }}
        onCancel={onClose}
      />
    </AppDialog>
  )
}
